import React from "react";
import { ElementsConsumer, PaymentElement } from "@stripe/react-stripe-js";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import { apiUri } from "../../config";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import "./register.css";

class CheckoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isProcessing: false,
    };
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ isProcessing: true });

    const { stripe, elements, history, user, selectedList, fromAceAlerts } =
      this.props;

    if (!stripe || !elements) {
      this.setState({ isProcessing: false });
      return;
    }

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        payment_method_data: {
          billing_details: {
            address: {
              country: "US",
            },
          },
        },
      },
      redirect: "if_required",
    });

    if (result.error) {
      NotificationManager.error(result.error.message, "Failure");
      this.setState({ isProcessing: false });
    } else if (result.paymentIntent.status === "succeeded") {
      const paymentIntent = result.paymentIntent;
      Axios.put(
        `${apiUri}/register/saveTransaction/${user.registrationUuid}?transactionId=${paymentIntent.id}`
      )
        .then((response) => {
          Axios.post(`${apiUri}/register/users/${user.registrationUuid}`, {registration: fromAceAlerts ? false : true})
            .then((res) => {
              NotificationManager.success("Payment successful!", "Success");
              if (fromAceAlerts) {
                // history.push("/ACEalerts");
                window.location.href = "/ACEalerts";
              } else {
                history.push({
                  pathname: "/Congratulations",
                  state: {
                    transactionDetails: paymentIntent,
                    user: user,
                    selectedCompanies: selectedList,
                  },
                });
              }
            })
            .catch((err) => {
              NotificationManager.error(err.message, "Failure");
              this.setState({ isProcessing: false });
            });
        })
        .catch((error) => {
          NotificationManager.error(error.message, "Failure");
          this.setState({ isProcessing: false });
        });
    }
  };

  render() {
    const { isProcessing } = this.state;
    const paymentElementOptions = {
      fields: {
        billingDetails: {
          address: {
            country: "never",
          },
        },
      },
    };

    return (
      <form onSubmit={this.handleSubmit} className="payment-details-form">
        <div className="payment-element-container">
          <PaymentElement options={paymentElementOptions} />
        </div>
        <button
          disabled={!this.props.stripe || isProcessing}
          className="sar-btn process-btn"
        >
          {isProcessing ? "Processing..." : "Process Payment"}
        </button>

        <NotificationContainer />
      </form>
    );
  }
}

const CheckoutFormWithRouter = withRouter(CheckoutForm);

export default function InjectedCheckoutForm(props) {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <CheckoutFormWithRouter
          stripe={stripe}
          elements={elements}
          {...props}
        />
      )}
    </ElementsConsumer>
  );
}



// WEBPACK FOOTER //
// ./src/components/Register/checkoutForm.jsx